module.exports = __webpack_public_path__ + "static/media/heart2.612909c4.webp";